import { NotificationManager } from 'react-notifications';
import Cookies from 'universal-cookie';
import { SERVER_API } from "../../../config.json"

const cookies = new Cookies();
let tokenUser = cookies.get('usercode');
function tokenAPI() {
    if (tokenUser.token) {
        return tokenUser.token;
    }
    else {
        NotificationManager.error('Mời bạn đăng nhập lại');
    }
}

function* GetDataDashboardFromApi(DataDashboard) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/GetDashboard", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataDashboard)
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {}
}
function* GetDataDashboard3FromApi(DataDashboard) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/GetDashboard3", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataDashboard)
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {}
}
function* GetDataDashboard4FromApi(DataDashboard) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/GetDashboard4", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataDashboard)
    });
    if (response.status === 403) {
        //NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
        window.location.href = '/'
    }
    else if (response.status === 404) {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data.status === "OK") {
            return yield Data.data;
        }
    }
    else {
        return yield {}
    }
}
function* GetDataDashboard5FromApi(DataDashboard) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/GetDashboard5", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataDashboard)
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {}
}
function* GetDataDashboard6FromApi(DataDashboard) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/PlanType/GetDashboard6", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataDashboard)
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {}
}
function* GetDataPlanDashboardFromApi(DataSearch) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/PlanType/GetDataTableReport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify(DataSearch),
    });
    // if (response.status === 403) {
    //     NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
    // }
    // else if (response.status === 404) {
    //     NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    // }
    // else 
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    } else {
        return yield {};
    }
}
function* GetDataPlanDashboard2FromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/PlanType/GetDataPlanDashboard', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test }
    });
    // if (response.status === 403) {
    //     NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
    // }
    // else if (response.status === 404) {
    //     NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    // }
    // else 
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    } else {
        return yield {};
    }
}
function* GetDataPlanDashboard3FromApi(DataPlan) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/PlanType/GetTimeExtension', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify(DataPlan),
    });
    // if (response.status === 403) {
    //     NotificationManager.warning("Bạn không có quyền trên chức năng này !", "", 8000);
    // }
    // else if (response.status === 404) {
    //     NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.", "", 8000);
    // }
    // else 
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    } else {
        return yield {};
    }
}
function* GetHeaderTableReportFromApi(ID) {
    var test = tokenAPI();
    // const cookies = new Cookies();
    // const userCode = cookies.get('usercode').userCode;
    const response = yield fetch(SERVER_API + 'api/PlanTypeConfiguration/GetHeaderTableReport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + test },
        body: JSON.stringify({ ID: ID }), //, CreateBy: userCode
    });
    if (response.status === 200) {
        const Data = yield response.json();
        return yield Data.data;
    } else {
        return yield {};
    }
}
//CreateFuntionHygen
export const Api = {
    GetDataDashboardFromApi,
    GetDataDashboard3FromApi,
    GetDataDashboard4FromApi,
    GetDataDashboard5FromApi,
    GetDataDashboard6FromApi,
    GetDataPlanDashboardFromApi,
    GetDataPlanDashboard2FromApi,
    GetDataPlanDashboard3FromApi,
    GetHeaderTableReportFromApi,
    //ExportFuntionHygen
}